export default "__VITE_ASSET__Cirx3ANi__"